import React, { useContext } from 'react';

import MetricCacheContext from 'contexts/MetricCacheContext';
import VisualisationCacheContext from 'contexts/VisualisationCacheContext';

import { useDebugMode } from './DebugModeProvider';

const MetricCacheBanner = () => {
  const { isDebugMode } = useDebugMode();
  const { normalMetricsCache, compoundMetricsCache } =
    useContext(MetricCacheContext);
  const { cache } = useContext(VisualisationCacheContext);

  if (!isDebugMode) {
    return null;
  }

  const totalMetricsCached =
    normalMetricsCache.size + compoundMetricsCache.size;
  const totalVisCached = cache.dashboardGadgets.size + cache.reportGadgets.size;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 8,
        left: 8,
        zIndex: 9999,
        padding: '4px 10px',
        borderRadius: 12,
        fontSize: 11,
        fontWeight: 600,
        backgroundColor: 'var(--color-bg-secondary)',
        color: 'var(--color-text-secondary)',
        border: '1px solid var(--color-border-primary)',
        pointerEvents: 'none',
      }}
    >
      Metrics cached: {totalMetricsCached} | Vis cached: {totalVisCached}
    </div>
  );
};

export default MetricCacheBanner;
